import React, { useState } from "react";
import * as S from "./SurveyView.style.js";
import { useStateValue } from "../../../../../contextAPI/StateProvider.js";
import useRecordNavigation from "../../../../../hooks/useRecordNavigation.js";
import { useMemo } from "react";

// utils
import { Actions } from "../../../../../utils/actionsIds.js";
import * as P from "../../../../../utils/pipes.js";
import { useTranslation } from "react-i18next";
import ZaiaInput from "../../../../zaiaComponents/zaiaInput/ZaiaInput.jsx";
import SurveyBox from "../surveyBox/SurveyBox.jsx";
import { useQuery } from "@apollo/client";
import { QUERY_GET_SURVEY_WITH_FREQUENCY } from "../../../../../graphql/queries/Surveys";
import PeriodOfTimeSelect from "../periodOfTimeSelect";
import Modal from "../../../../../utils/modal.js";
import ModalSendSurvey from "../modalSendSurvey";
import ZaiaReaction from "../../../../zaiaComponents/zaiaReaction/ZaiaReaction.jsx";
import FlorenzButton from "../../../../florenzComponents/florenzButton/FlorenzButton.jsx";

// Assets
const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;
const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;
const zaiaEmpty = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/no-results.svg`;

function SurveyView({
  surveySelected,
  setSurveySelected
}) {

  const { recordAction } = useRecordNavigation();
  const [{ selectedPatient }, dispatch] = useStateValue();
  const [processSelected, setProcessSelected] = useState(selectedPatient?.userToProcesses[0].process?.id);
  const { i18n: { language }, t } = useTranslation("global");
  const [filterText, setFilterText] = useState("");
  const [initialDateRange, setInitialDateRange] = useState();
  const [finishDateRange, setFinishDateRange] = useState();
  const [surveyPreview, setSurveyPreview] = useState()

  const getText = (e) => {
    console.log(e);
    setFilterText(e);
  }

  const { data: surveyData, loading: surveyDataLoading, error: surveyDataError } = useQuery(QUERY_GET_SURVEY_WITH_FREQUENCY, {
    variables: {
      customFormId: surveySelected,
      initialDate: initialDateRange,
      finalDate: finishDateRange
    }
  })

  const getSurveysInfoByFrequencies = () => {
    return surveyData?.customForm[0].customFormFrequency.map((frequencies) => {
    
      return {
        customFormId: frequencies?.customFormId,
        userId: frequencies?.user?.id,
        user: frequencies?.user,
        date: frequencies?.created_at,
        frequency: frequencies?.frequency,
        frenquencyType: frequencies?.frequencyType,
        answersQuantity: frequencies?.user?.customFormHistories.length,
      }
    })
  }

  const getSurveysInfoByDoctorUpload = () => {

    const surveysHistoryList = []

    surveyData?.customForm[0].userCustomFormHistories.filter((history) => history.savedByDoctor).forEach((history) => {    

      if(!surveysHistoryList.find(survey => survey.userId === history?.user.id)) {
        surveysHistoryList.push({
          customFormId: history?.customFormId,
          userId: history?.user.id,
          user: history?.user,
          date: history?.created_at,
          frequency: null,
          frenquencyType: null,
          answersQuantity: surveyData?.customForm[0].userCustomFormHistories.filter((item) => item?.user.id === history?.user.id).length,
        })
      }
    })

    return surveysHistoryList;
  }

  const surveyListItems = useMemo(() => {

    let listItems = [];

    if(surveyData?.customForm[0].customFormFrequency.length > 0) {
      listItems = listItems.concat(getSurveysInfoByFrequencies());
    } 

    if(surveyData?.customForm[0].userCustomFormHistories.filter((history) => history.savedByDoctor).length > 0) {

      getSurveysInfoByDoctorUpload().forEach((surveyData) => {

        const existUserInList = listItems.find(survey => survey.userId === surveyData?.userId);
        if( existUserInList && new Date(surveyData.date) > new Date(existUserInList.date) ) {
          listItems = [...listItems.filter(survey => survey.userId !== surveyData?.userId), surveyData];
        }

        if(!existUserInList) {
          listItems.push(surveyData);
        }
      })
    }

    return listItems;

  }, [surveyData])
  
   return <S.SurveyView>
    <Modal open={surveyPreview}>
      <ModalSendSurvey
        setModalActive={setSurveyPreview}
        surveyForPreview={surveyPreview}
      />
    </Modal>
    <div className="toolbar">
      <div className="toolbar__left">
        <button className="back-button"
          onClick={() => setSurveySelected(false)}
        >
          <i className="back-button__icon icon zaia-icono-atras"></i>
        </button>
        <div className="survey-info">
          {P.dataTranslation(surveyData?.customForm[0].customFormName, language)}
        </div>
      </div>
      <div className="toolbar__right">
        <div className="select-container">
          <div className="select-container__label">
            {t("surveys.surveysOf")}
          </div>
          <PeriodOfTimeSelect 
            initialDateRange={initialDateRange}
            finishDateRange={finishDateRange}
            setInitialDateRange={setInitialDateRange}
            setFinishDateRange={setFinishDateRange}
          />
        </div>
      </div>
    </div>

    <div className="section">
      <div className="section__content">
        <div className="section__left">
          <div className="survey-process">{
            t("globally.process") + " " +
            P.dataTranslation(surveyData?.customForm[0].processToCustomForms.find(process => process.process !== null).process.processName, language)
          }</div>
        </div>
        <div className="section__right">
          <FlorenzButton
            typeStyle={"secondaryWhite"}
            size="s"
            text={t("surveys.preview")}
            widthComplete={true}
            onClick={() => {
              setSurveyPreview(surveyData?.customForm[0].id)
            }}
          />
        </div>
      </div>
    </div>

    <div className="surveys-section">
      <SurveysListContainer
        surveyData={surveyData}
        surveyListItems={surveyListItems}
        surveyDataError={surveyDataError}
        surveyDataLoading={surveyDataLoading}
      />
    </div>
  </S.SurveyView>
}

const SurveysListContainer = ({ 
  surveyData,
  surveyListItems,
  surveyDataError,
  surveyDataLoading
 }) => { 
  
  const { i18n: { language }, t } = useTranslation("global");

  if(surveyDataLoading) 
    return (
      <div className="survey-list survey-list--reaction">
        <ZaiaReaction
          widthimg="150px"
          zaiaImg={logoZaiaLoading}
        /> 
      </div>
    )

  if(surveyDataError) 
    return (
      <div className="survey-list survey-list--reaction">
        <ZaiaReaction
          zaiaImg={logoZaiaAlert}
          widthimg="100px"
          text={t("globally.errorLoadingSurveys")}
          sizeText="15px"
          widthText="240px"
        />
      </div>
    )

  if(surveyListItems.length === 0) 
    return (
      <div className="survey-list survey-list--reaction">
        <ZaiaReaction
          zaiaImg={zaiaEmpty}
          text={t("surveys.noSurveys")}
          // subText={}
          sizeText="33.25px"
          sizeSubText="15px"
          textColor="var(--blue-color)"
          widthimg="210px"
        />
      </div>
    )  

  return (
    <div className="survey-list">
      <div className="survey-table">
        <table>
          <thead>
            <tr>
              <th>{t("globally.patientName")}</th>
              {/* <th>Status</th> */}
              <th>{t("surveys.lastSentDate")}</th>
              <th>{t("surveys.answeredTimes")}</th>
              <th>{t("globally.frequency")}</th>
              <th>{t("globally.quickActions")}</th>
              {/* <th>Delicate results</th> */}
            </tr>
          </thead>
          <tbody>
            {
              surveyListItems.map(
                (surveyinfo) => {
                  return <SurveyBox 
                    key={surveyinfo.userId}
                    data={surveyinfo}
                    surveyData={surveyData}
                    analysisActived={surveyData?.customForm[0].isInteractive}
                  />
                }
              )

            }
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SurveyView;